import { Elements } from '@stripe/react-stripe-js';
import type { Stripe } from '@stripe/stripe-js';
import { loadStripe } from '@stripe/stripe-js';
import invariant from 'invariant';
import type { FunctionComponent, ReactNode } from 'react';
import { useMemo } from 'react';

import { useAppConfig } from '#/config/AppConfigContext';

type Props = {
  children: ReactNode;
};

let globalStripePromise: Promise<Stripe | null> | undefined;

export function IdealistStripeProvider({ children }: Props) {
  const { appConfig } = useAppConfig();
  const { publishableKey } = appConfig.stripe;

  const stripePromise = useMemo(() => {
    if (!globalStripePromise) {
      invariant(publishableKey, 'Missing STRIPE_PUBLISHABLE_KEY');

      globalStripePromise = loadStripe(publishableKey);
    }

    return globalStripePromise;
  }, [publishableKey]);

  return <Elements stripe={stripePromise}>{children}</Elements>;
}

export function withIdealistStripeProvider<T>(Component: FunctionComponent<T>) {
  return function componentWithIdealistProvider(props: T) {
    return (
      <IdealistStripeProvider>
        {/* @ts-expect-error fix types */}
        <Component
          // eslint-disable-next-line react/jsx-props-no-spreading
          {...props}
        />
      </IdealistStripeProvider>
    );
  };
}
